import React, { useState } from 'react'
import { Panel, Row, Col, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import AppContext from '../../context/AppContext'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  ExprotMigrateBorrowAdvance,
  GetMigrateBorrowAdvanceEfin,
  GetMigrateEfin,
} from '../../redux/actions/migrateEfin'
import { budgetFormat } from '../../utils/formatterUtil'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'
import InputForm from '../../components/forms/input/InputForm'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import { downloadFile } from '../../utils/fileUtil'
import moment from 'moment'

export default function BorrowAdvanceMGEfin(props) {
  const { schema } = props
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table

  const [isLoading, setIsLoading] = useState(false)
  const [searchResult, setSearchResult] = useState()

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  const defaultMaxFileSize = 50

  const handleSearch = async (projectCode, period) => {
    startLoading()
    setIsLoading(true)
    try {
      // setSearchResult(mockData)
      let response = await GetMigrateBorrowAdvanceEfin(projectCode, period)

      if (response.model && !response.didError) {
        setSearchResult(response.model)

        notification.open('success', {
          title: `แสดงข้อมูลสำเร็จ`,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleExportExcel = async (data) => {
    startLoading()
    setIsLoading(true)
    try {
      // setSearchResult(mockData)
      let file = await ExprotMigrateBorrowAdvance(data)

      if (file) {
        downloadFile(
          file,
          `ข้อมูลเงินยืมทดรองจ่าย_${searchResult.projectCode}_งวด_${
            searchResult.period
          }_${moment().format('YYYYMMDDHHmmss')}.xlsx`
        )
      } else {
        notification.open('error', {
          title: file?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log(e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    handleSearch(data.projectCode, data.period)
  }

  return (
    <div>
      <Panel
        header={schema.header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 20 }}
      >
        {isLoading && <OverlayLoader />}

        <Row>
          <Col xs={24} sm={1} md={2} lg={2}></Col>
          {schema.projectCode && (
            <Col xs={24} sm={11} md={10} lg={10}>
              <InputForm
                schema={schema.projectCode}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          )}
          {schema.period && (
            <Col xs={24} sm={11} md={10} lg={10}>
              <InputForm
                isInputNumber
                schema={schema.period}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          )}
          <Col xs={24} sm={1} md={2} lg={2}></Col>
        </Row>
        <Row style={{ marginTop: 20, textAlign: 'right' }}>
          <Col>
            <SearchButton onClick={handleSubmit(onSubmit)} />
          </Col>
        </Row>
        <hr />
        {searchResult && (
          <Row style={{ marginTop: 20 }}>
            <Col>
              <b>รหัสโครงการ : </b>
              {searchResult.projectCode}
            </Col>
            <Col>
              <b>ชื่อโครงการ : </b>
              {searchResult.projectName}
            </Col>
            <Col>
              <b>เลขที่ข้อตกลง : </b>
              {searchResult.contractNo}
            </Col>
            <Col>
              <b>งวดที่ : </b>
              {searchResult.period}
            </Col>
            <Col align="right">
              <DownloadButton
                children="ดาวน์โหลด Excel"
                onClick={() => {
                  handleExportExcel(searchResult)
                }}
              />
            </Col>
          </Row>
        )}

        <Table
          style={{ marginTop: 5 }}
          wordWrap
          autoHeight={searchResult?.datas?.length < 6}
          height={(searchResult?.datas || []).length == 0 ? 200 : 400}
          data={searchResult?.datas || []}
          loading={isLoading}
        >
          <Column align="center" width={100} fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={130} fixed>
            <HeaderCell>รหัสโครงการ</HeaderCell>
            <Cell dataKey="projectCode" />
          </Column>

          <Column align="center" width={120}>
            <HeaderCell>งวดที่ยืมเงิน</HeaderCell>
            <Cell dataKey="periodNo" />
          </Column>

          <Column width={160}>
            <HeaderCell>เลขที่เอกสารอ้างอิง</HeaderCell>
            <Cell dataKey="documentNo" />
          </Column>

          <Column width={150}>
            <HeaderCell>วันที่ในเอกสาร</HeaderCell>
            <Cell dataKey="documentDate" />
          </Column>

          <Column align="right" width={120}>
            <HeaderCell>ยอดเงินยืม</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.borrowAmount)
              }}
            </Cell>
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่ยืม</HeaderCell>
            <Cell dataKey="borrowDate" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่กำหนดคืน</HeaderCell>
            <Cell dataKey="retrunDueDate" />
          </Column>
          <Column width={150}>
            <HeaderCell>ชื่อผู้ยืมเงินทดรองจ่าย</HeaderCell>
            <Cell dataKey="borrowerName" />
          </Column>
          <Column width={160}>
            <HeaderCell>เลขที่บัตรประชาชน</HeaderCell>
            <Cell dataKey="borrowerIdCard" />
          </Column>
          {/* <Column width={150}>
            <HeaderCell>ประเภทผู้ยืมเงิน</HeaderCell>
            <Cell dataKey="borrowerTypeName" />
          </Column> */}
          <Column width={150}>
            <HeaderCell>ยืมทำกิจกรรม</HeaderCell>
            <Cell dataKey="activity" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่เริ่มต้นกิจกรรม</HeaderCell>
            <Cell dataKey="activityStartDate" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่สิ้นสุดกิจกรรม</HeaderCell>
            <Cell dataKey="activityEndDate" />
          </Column>
          <Column width={120}>
            <HeaderCell>จ่ายโดย</HeaderCell>
            <Cell dataKey="payTypeName" />
          </Column>
          <Column width={250}>
            <HeaderCell>ธนาคาร</HeaderCell>
            <Cell dataKey="bankName" />
          </Column>
          <Column width={150}>
            <HeaderCell>สาขา</HeaderCell>
            <Cell dataKey="bankBranch" />
          </Column>
          <Column width={120}>
            <HeaderCell>ประเภทบัญชี</HeaderCell>
            <Cell dataKey="accountTypeName" />
          </Column>
          <Column width={200}>
            <HeaderCell>เลขที่บัญชี</HeaderCell>
            <Cell dataKey="accountNo" />
          </Column>
          <Column width={350}>
            <HeaderCell>ชื่อบัญชี</HeaderCell>
            <Cell dataKey="accountName" />
          </Column>
          <Column width={350}>
            <HeaderCell>คำอธิบาย วัตถุประสงค์การยืม</HeaderCell>
            <Cell dataKey="borrowRemark" />
          </Column>
        </Table>
      </Panel>
    </div>
  )
}
